import { ForestProductPriceUpdateDetail } from '../../../../components/ForestProduct/ForestProductPriceUpdates/ForestProductPriceUpdateDetail';

export function ForestProductPriceUpdateDetails() {
  return <ForestProductPriceUpdateDetail />;
}
